import { useTranslation } from 'react-i18next';
import { GLOBAL_NAVIGATION_HEIGHT } from '@/shared/lib/constants';
import { useRouteSidePanelStore } from '@/shared/stores/side-panel-store';
import { Banner } from '@/shared/ui';
import { SideMenuHeader } from '@/widgets/right-side-menu/ui/SideMenuHeader';
import { ExpenditureEditForm } from './ExpenditureEditForm';

/**
 * 歳出コード振り結果 訂正サイドパネル
 *
 * 歳出テーブルの行を選択した際に表示されるコンテナ。
 * ヘッダーと ExpenditureEditForm を配置する。
 */
export const ExpenditureEditSidePanel = () => {
  const { t } = useTranslation();
  const requestClose = useRouteSidePanelStore((state) => state.requestClose);
  const mode = useRouteSidePanelStore((state) => state.mode);

  const initialFormValue =
    mode?.type === 'settlement-statistics-converter.expenditure-edit' ? mode : undefined;

  return (
    <div
      className="flex flex-col overflow-hidden"
      style={{ height: `calc(100vh - ${GLOBAL_NAVIGATION_HEIGHT}px)` }}
    >
      <SideMenuHeader
        onClose={() => {
          requestClose();
        }}
      />
      {initialFormValue ? (
        <ExpenditureEditForm
          convertResultId={initialFormValue.convertResultId}
          selectedExpenditure={initialFormValue.expenditure}
          onClose={requestClose}
        />
      ) : (
        <Banner
          type="error"
          title={t('common.status.error')}
          description={t('common.status.no-data')}
        />
      )}
    </div>
  );
};
